import { toast } from "react-hot-toast";
import "../../StyleSheet/AppComponent/responsiveToast.scss";

const isMobile = () =>
  typeof window !== "undefined" && window.innerWidth <= 768;

export const responsiveToast = (message, type = "error") => {
  toast.custom(
    (t) => (
      <div
        className={`responsive-toast ${type} ${
          isMobile() ? "mobile" : "desktop"
        }`}
      >
        <span className="message">{message}</span>
        <button
          className="close-btn"
          onClick={() => {            
            toast.dismiss(t.id)            
          }}
          aria-label="Close notification"
        >
          ✕
        </button>
      </div>
    ),
    {
      position: isMobile() ? "bottom-center" : "top-right",
      duration: 5000,
    }
  );
};
